import { Navbar } from "./navbar";
import { useEffect } from "react";

import safety from "../assets/images/safety.jpg"
import safetyIco1 from "../assets/images/safetyIco1.svg"
import safetyIco2 from "../assets/images/safetyIco2.svg"
import safetyIco3 from "../assets/images/safetyIco3.svg"
import safetyIco4 from "../assets/images/safetyIco4.svg"
import safetyIco5 from "../assets/images/safetyIco5.svg"
import { Link } from "react-router-dom";


export function Safety() {
    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])
    return(
        <div className="safetyPage">
            <div className="container">
                <Navbar />
            </div>
           
            <section className="safetySec"> 
                <div className="container">
                    <h1 className="heading56 mb-4">Safety</h1>
                    <div className="titileText">Safety is the top priority of Corolla Roofing.</div>
                    <div className="row">
                        <div className="col-lg-7 order-lg-1 order-2">
                            <p className="text22 mb-0">At Corolla Roofing, we place an extreme value on workplace and roofing project safety. Every one of our experienced roofing technicians and support team members is trained in local, state, and federal regulations concerning safety measures and practices. That includes rules and standards from the Environmental Protection Agency, Occupational Safety and Health Administration, and Department of Transportation. Our commitment to these standards is reinforced daily through health and safety meetings with all on-site team members. </p>
                            <Link to="/about" className="blueOutlineBtn mt-5">More About Us</Link>
                        </div>
                        <div className="col-lg-5 order-lg-2 order-1 text-center">
                            <div className="imgDiv">
                                <img src={safety} alt="homeImg1" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="differentSec">
                <div className="container">
                    <p className="text22 text-center">Corolla Roofing blends the modern technology and tools of today with old-fashioned superior craftwork, New Englanders know and trust. Our roofing experts rely on years of experience handling durable, aesthetically pleasing projects, and problem-solving for our area's different seasons and weather.</p>
                    <div className="row mt-5 jc-center">
                        <div className="col-lg-4 col-sm-6 mb-4"> 
                            <DifferentCard image={safetyIco1}  desc="Eliminate personal injuries and/or property loss" />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={safetyIco2}  desc="Achieve greater efficiency" />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={safetyIco3} desc=" ensure a long-lasting roof solution." />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={safetyIco4} desc="Ensure the safety of our experienced team " />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={safetyIco5} desc="Solidify our reputation as seasoned professionals" />
                        </div>
                       
                    </div>
                </div>
            </section>

            <section className="planSec">
                <div className="container">
                    <div className="title">The overall effectiveness of our program depends upon the active participation and cooperation of management, project supervisors, and employees in carrying out the following basic procedures:</div>
                    <div className="points">1. Plan all work to minimize personal injury, property damage, and loss of productive time</div>
                    <div className="points">2. Maintain a system of prompt detection and correction of unsafe practices and conditions</div>
                    <div className="points">3. Establish and conduct safety training programs that educate, stimulate, and maintain the interest and cooperation of employees in working safely and efficiently</div>
                    <div className="points">4. Insistence upon the proper use of personal protective equipment, mechanical safety devices and guards, and the appropriate use of tools and equipment</div>
                    <div className="points">5. Require all subcontractors, supervisors, and employees to be familiar with the Corolla Roofing Corporate Safety Program and all local, state, and federal regulations and contract requirements pertaining to safety.</div>
                    <p className="my-4 text22">All material Safety and Data Sheets (MSDS) and First Aid Kits are readily available on-site at all times.</p>
                    <p className="mb-0 text22">If you have any questions concerning our safety procedures or would like to learn more about how we will work with your specific location, please send us a note through our contact page. </p>
                </div>
            </section>


        </div>
    )
}

const DifferentCard = ({image, title,desc}) =>{
    return(
       <div className="difftrerntCard">
           <div className="logoDiv">
               <img src={image} alt="experience" />
           </div>
           <div className="title mt-1 mb-3">{title}</div>
           <p>{desc}</p>
       </div>
    )
   }

